import { Link } from '@natu/next-link';
import { ButtonWithEvent } from '@natu/ui/Button/ButtonWithEvent';
import { ResponsiveImage } from '@natu/ui/ResponsiveImage';

import {
  type SBProps,
  type StoryblokAsset,
  type StoryblokLink,
  getAssetFromStoryblok,
  getLinkPropsFromStoryblok,
  sbEditable,
} from '../../../../utils';

interface SBLogoProps {
  asset?: StoryblokAsset;
  link?: StoryblokLink;
  srLabel?: string;
}

export const SBLogo = ({ blok }: SBProps<SBLogoProps>) => {
  const { asset, link, srLabel } = blok;

  const img = getAssetFromStoryblok(asset, { type: 'image' });
  const linkProps = getLinkPropsFromStoryblok(link);

  if (!img.src || !linkProps.href) {
    return null;
  }

  return (
    <ButtonWithEvent
      event="E_click_logo_home"
      variant={null}
      size="link"
      aria-label={srLabel || img.alt}
      asChild
    >
      <Link {...linkProps} {...sbEditable(blok)}>
        <ResponsiveImage className="h-8 w-24" width={120} height={40} priority {...img} />
      </Link>
    </ButtonWithEvent>
  );
};
